module.exports = __webpack_public_path__ + "static/stamford-fencing-center-4440835606d61bad85b19289cbf49a07.png";